import React from 'react';

interface Props {
  x: number;
  y: number;
  colour: string;
  fontSize: number;
  bold: boolean;
  italic: boolean;
  underline: boolean;
  onChange: (partial: { color?: string; fontSize?: number; bold?: boolean; italic?: boolean; underline?: boolean }) => void;
  onDelete: () => void;
  onClose: () => void;
}

const COLORS = ['#ddd6fe', '#bfdbfe', '#bbf7d0', '#fbcfe8', '#fef08a'];

const NodeToolbar: React.FC<Props> = ({ x, y, colour, fontSize, bold, italic, underline, onChange, onClose, onDelete }) => {
  const [showPalette,setShowPalette] = React.useState(false);

  return (
    <div
      className="absolute z-50 bg-gray-900/90 text-white rounded-lg shadow-xl flex items-center gap-2 px-3 py-2"
      style={{ left: x, top: y }}
      onMouseLeave={()=>setShowPalette(false)}
    >
      {/* Colour picker */}
      <div className="relative">
        <button className="w-4 h-4 rounded-full border-2 border-white" style={{backgroundColor: colour}} onClick={()=>setShowPalette(p=>!p)} />
        {showPalette && (
          <div className="absolute -left-4 top-6 bg-gray-800/95 p-2 rounded-md flex gap-1">
            {COLORS.map(c=>(
              <div key={c} className={`w-4 h-4 rounded-full border-2 ${colour===c?'border-blue-400':'border-transparent'} cursor-pointer`} style={{backgroundColor:c}} onClick={()=>{onChange({color:c}); setShowPalette(false);}} />
            ))}
          </div>
        )}
      </div>
      {/* Font size */}
      <div className="flex items-center gap-1">
        <button className="px-1 text-xs hover:bg-gray-700 rounded" onClick={()=>onChange({fontSize: fontSize-1})}>A-</button>
        <span className="text-xs w-5 text-center">{fontSize}</span>
        <button className="px-1 text-xs hover:bg-gray-700 rounded" onClick={()=>onChange({fontSize: fontSize+1})}>A+</button>
      </div>
      {/* Text styles */}
      <button className={`px-1 text-sm font-bold rounded ${bold?'bg-gray-700':''}`} onClick={()=>onChange({bold: !bold})}>B</button>
      <button className={`px-1 italic text-sm rounded ${italic?'bg-gray-700':''}`} onClick={()=>onChange({italic: !italic})}>I</button>
      <button className={`px-1 underline text-sm rounded ${underline?'bg-gray-700':''}`} onClick={()=>onChange({underline: !underline})}>U</button>
      <button className="px-1 ml-2 hover:bg-red-600 rounded" onClick={onDelete}>🗑</button>
      <button className="text-xs ml-1" onClick={onClose}>✕</button>
    </div>
  );
};

export default NodeToolbar; 